// extracted by mini-css-extract-plugin
export default {"resend":"resend_resend__zH45w","resendPointer":"resend_resendPointer__NXl7x"};